import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { compose } from 'recompose'
import { Select } from 'components/fields'
import { wizard, meta } from 'helpers/decorators'
import {
  apiAwards,
  apiLocales, apiParticipants,
} from 'helpers/decorators/api'
import { Button, Note, Title } from 'components/misc'
import validate from '../Language/language.validation'
import mapOrgRegLocales from '../../../../redux/selectors/locales/mapOrgRegLocales'
import { connect } from 'react-redux'
import { initializeFormFields } from '../../../../helpers/formInitializationHelper'


const enhance = compose(
  apiAwards(),
  apiLocales(),
  apiParticipants(),
  wizard({
    form: 'participantRegistration',
    multipage: true,
    destroyOnUnmount: false,
    validate,
    disableHook: true
  }),
  meta({
    title: 'Register participant',
    intlKey: 'pageTitle.register_participant'
  }),
  connect(
    ({ api }) => ({
      registrationInfo: get(api, 'participants.registrationInfo')
    }), {}
  )
)

class Language extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func,
    values: PropTypes.object,
    change: PropTypes.func.isRequired,
    locales: PropTypes.object,
    changeLocale: PropTypes.func,
    getPublicLevels: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    registrationInfo: PropTypes.object
  }

  constructor(props) {
    super(props)

    this.state = {
      organizationLanguage: undefined
    }
  }

  componentDidMount = async() => {
    const registrationInfo = get(this.props, 'registrationInfo')

    if (registrationInfo) {
      const fieldsToInit = [
        { name: 'localeId', value: get(registrationInfo, 'localeId', null) },
      ]

      initializeFormFields(this.props, fieldsToInit)
    }
  }

  getOrgRegLocales = () => {
    return get(this.props, 'values.helpers.orgRegLocales')
  }

  handleSelectLanguage =  ({ value } = {}) => {
    const { locales, changeLocale } = this.props

    if (value) {
      const updateLocale = locales.data.filter(item => item.id === value)[0]

      try {
        const { getPublicLevels } = this.props
        changeLocale(updateLocale)
        getPublicLevels()
      } catch (err) {
        console.log(err)
      }
    }
  }

  render() {
    const { onSubmit, handleSubmit } = this.props

    return (
      <form
        onSubmit={handleSubmit(onSubmit)}
        data-testId="registrationWelcomeForm"
      >
        <Title h1>
          <FormattedMessage
            id="moduleTitle.confirm_lang_choice"
            defaultMessage="Confirm you language choice"
          />
        </Title>

        <Note lighter margin="0 0 35px 0">
          <FormattedMessage
            id="label.following_lang_are_available"
            defaultMessage="The following languages are available for you"
          />
        </Note>
        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <Select
              label="Select language"
              intlKey="label.select_lang"
              name="localeId"
              options={mapOrgRegLocales(this.getOrgRegLocales())}
              onSelectChange={this.handleSelectLanguage}
              searchable
            />

          </div>
        </div>
        <div>
          <Button type="submit">
            <FormattedMessage id="button.continue" defaultMessage="Continue" />
          </Button>
        </div>
      </form>
    )
  }
}

export default enhance(Language)
